import React from "react";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";

// Custom-colour orders are produced as SILVER: from Production until the
// packing checklist is finished the factory / packing stations see "Silver";
// afterwards the order shows its real custom colour again. The stored
// `color` never changes — this is a display rule only.
export const PRODUCTION_COLOR = "Silver";
export const CUSTOM_HOLD_STAGES = new Set(["production", "product_transfer", "packing"]);
export const isCustomColor = (c) => /custom/i.test(c || "");

export function effectiveColor(o) {
  const original = o?.color || "";
  if (isCustomColor(original) && CUSTOM_HOLD_STAGES.has(o?.status)) {
    return { color: PRODUCTION_COLOR, held: true, original };
  }
  return { color: original, held: false, original };
}

// Small "*" next to a held colour — hover shows the original custom colour.
export function CustomColorNote({ ec, testid = "custom-color-note", className = "" }) {
  if (!ec?.held) return null;
  return (
    <HoverCard openDelay={100} closeDelay={80}>
      <HoverCardTrigger asChild>
        <span
          className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-amber-100 border border-amber-400 text-amber-800 text-[11px] font-black leading-none cursor-help select-none ${className}`}
          data-testid={testid}
          aria-label={`Original colour: ${ec.original}`}
        >
          *
        </span>
      </HoverCardTrigger>
      <HoverCardContent side="top" align="start" className="w-72 p-3 text-xs" data-testid={`${testid}-popup`}>
        <div className="font-semibold text-slate-900">Custom colour — shown as {PRODUCTION_COLOR}</div>
        <div className="mt-1 text-slate-700">
          Original colour: <span className="font-mono font-bold text-slate-900">{ec.original}</span>
        </div>
        <div className="mt-1 text-slate-500">
          Produced and packed as {PRODUCTION_COLOR}; switches back to the custom colour once packing is finished.
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
